import { useState } from "react"

// Whether a chart's legends (its strategy and indicators) are folded away, as TradingView's ^
// button under them does. Per chart position, remembered in this browser.

const key = (pane: number) => `trader.chart.legendsFolded.${pane}`

const load = (pane: number): boolean => {
  try {
    return localStorage.getItem(key(pane)) === "true"
  } catch {
    return false
  }
}

export const useLegendsFolded = (pane: number): readonly [boolean, (folded: boolean) => void] => {
  const [folded, setFolded] = useState(() => load(pane))
  const set = (next: boolean) => {
    setFolded(next)
    try {
      localStorage.setItem(key(pane), String(next))
    } catch {
      // Not remembered; the fold still applies now.
    }
  }
  return [folded, set] as const
}
